export default {
  "navInfo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["导航栏数据"])},
  "topNav": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顶部导航栏设置"])}
}